(function () {
  function bind() {
    document.querySelectorAll('.magnetic-glow:not([data-mg-bound])').forEach(function (el) {
      el.setAttribute('data-mg-bound', '1');
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        el.style.setProperty('--mg-x', x + 'px');
        el.style.setProperty('--mg-y', y + 'px');
      });
    });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
